import { CreatePurchaseContract } from '../types/create-purchase-contract';
import { removeMask } from './remove-mask';
import { Checkout } from '../types/checkout';
import { getAllUrlParams, getUrlParams } from './get-url-params';

export const stripeErrorToMessage = (code?: string) => {
  switch (code) {
    case 'incomplete_number':
    case 'invalid_number':
      return 'Número do cartão inválido.';
    case 'incomplete_expiry':
      return 'Data de validade incompleta.';
    case 'invalid_expiry_year_past':
      return 'Ano de validade já passou.';
    case 'incomplete_cvc':
    case 'invalid_cvc':
      return 'CVV inválido.';
    default:
      return 'Erro ao validar cartão. Tente novamente.';
  }
};

export const buildCommonCC = (data: CreatePurchaseContract) => ({
  emailComprador: data.email,
  nomeComprador: data.fullName,
  sobrenomeComprador: data.fullName,
  cpfComprador: removeMask(data.cpf),
  telefoneComprador: removeMask(data.phoneNumber),
  postalCode: data?.postalCode,
  state: data?.state,
  city: data?.city,
  district: data?.neighborhood,
  address: data?.address,
  number: data?.number,
  complement: data?.complement,
  utmSource: getUrlParams('utm_source'),
  utmCampaign: getUrlParams('utm_campaign'),
  utmMedium: getUrlParams('utm_medium'),
  utmContent: getUrlParams('utm_content'),
  utmTerm: getUrlParams('utm_term'),
  sck: getUrlParams('sck') ?? undefined,
  src: getUrlParams('src') ?? undefined,
  urlParams: getAllUrlParams(),
});

export const goToProcessing = (
  navigate: any,
  locationSearch: string,
  purchase: any,
  checkout: Checkout,
  contract: Partial<CreatePurchaseContract>,
) => {
  const params = new URLSearchParams(locationSearch);
  navigate(`/venda/processando?${params?.toString()}`, {
    state: { purchase, checkout, contract },
  });
};
